import { MultiFactorType } from '../../enums/auth/multi-factor-type';

export class MFAConfigPayload {
	mfaType: MultiFactorType = MultiFactorType.OtpCode;
}
